
import http from "../http";
const apiEndpoint = process.env.REACT_APP_BASE_URL +  "/api/Db";

export function doMigrate() {
    return http.post(`${apiEndpoint}/Migrate`);
  }